<template>
  <div>
    <div style="width: 100vw; height: 100vh">
      <div class="member-info" style="position: relative">
        <van-cell>
          <template #title>
            <div style="display: inline-flex">
              <div style="margin: 10px 10px 10px 0;border: 1px solid #2196f3;background-color: #2196f3;height:48px;width: 48px;border-radius: 24px;text-align: center;">
                <van-icon name="manager-o" size="32" style="margin-top: 4px;" /></div>
              <ul style="margin: 10px 0">
                <li>{{ usr.username }}</li>
                <li>UID:{{ usr.id }}</li>
                <li style="display: none">VIP:{{ usr.vip }}</li>
                <li style="display: none">
                  {{ $t('member.reputation') }} : {{ usr.credit_score }}
                </li>
              </ul>
            </div>
          </template>
        </van-cell>
        <div style="position: absolute; top: -40px; right: 20px">
          <van-icon name="wap-home-o" size="32" style="margin-top: 60px" @click="closeWin" />
        </div>
      </div>
      <div style="text-align: center;background-color:rgb(9, 31, 48);padding: 10px;">
        <img src="@/assets/img_2.jpg" style="margin: 0px auto;width: 90%;border-radius: 8px;" />
      </div>
      <div class="member-menu-box">
        <van-cell-group>
          <van-cell
            :title="$t('member.identity_authentication')"
            is-link
            :to="
              usr.rzstatus == 0 || usr.rzstatus == 3
                ? '/real_authentication'
                : ''
            "
            v-if="safeWapConfig.certification_switch == 1"
          >
            <template #icon>
              <svg-icon icon-class="identity" class="member-icon" />
            </template>
            <template>
              <div :class="usr.rzstatus == 2 ? 'data-up' : 'data-down'">
                {{ getRzStatus(usr.rzstatus) }}
              </div>
            </template>
          </van-cell>
          <van-cell
            v-if="safeWapConfig.address_switch == 1"
            :title="$t('member.binding_withdrawal_address')"
            is-link
            to="/bindMentionAddress"
          >
            <template #icon>
              <svg-icon icon-class="address" class="member-icon" />
            </template>
          </van-cell>
          <van-cell
            v-if="safeWapConfig.bank_switch == 1"
            :title="$t('bank.title')"
            is-link
            to="/bank"
          >
            <template #icon>
              <svg-icon icon-class="bank" class="member-icon" />
            </template>
          </van-cell>
          <van-cell
            :title="$t('member.sharing_link')"
            is-link
            @click="tosharing()"
          >
            <template #icon>
              <svg-icon icon-class="sharing" class="member-icon" />
            </template>
          </van-cell>
          <van-cell :title="$t('member.system_message')" is-link to="/notify">
            <template #title>
              <van-badge dot v-if="usr.has_unread && usr.has_unread > 0">
                {{ $t('member.system_message') }}
              </van-badge>
              <span v-else>{{ $t('member.system_message') }}</span>
            </template>
            <template #icon>
              <svg-icon icon-class="message" class="member-icon" />
            </template>
          </van-cell>
          <van-cell style="display: none" :title="$t('member.night_mode')">
            <template #icon>
              <svg-icon icon-class="night_mode" class="member-icon" />
            </template>
            <template>
              <van-switch v-model="checked" size="24px" @click="changeTheme" />
            </template>
          </van-cell>
          <van-cell
            :title="$t('member.security_center')"
            is-link
            to="/security"
          >
            <template #icon>
              <svg-icon icon-class="password" class="member-icon" />
            </template>
            <template>
              <div :class="usr.have_pay == 1 ? 'data-up' : 'data-down'">
                {{ gethave_pay(usr.have_pay) }}
              </div>
            </template>
          </van-cell>
          <van-cell
            style="display: none"
            v-if="
              isIOS && safeWapConfig.ios_url && safeWapConfig.ios_url.length > 0
            "
            :title="$t('member.app_download')"
            is-link
            @click="Download()"
          >
            <template #icon>
              <svg-icon icon-class="appdown" class="member-icon" />
            </template>
          </van-cell>
          <van-cell
            style="display: none"
            v-else-if="
              !isIOS &&
              safeWapConfig.android_url &&
              safeWapConfig.android_url.length > 0
            "
            :title="$t('member.app_download')"
            is-link
            @click="Download()"
          >
            <template #icon>
              <svg-icon icon-class="appdown" class="member-icon" />
            </template>
          </van-cell>
          <van-cell
            style="display: none"
            v-if="safeWapConfig.introduce_switch == 1"
            :title="$t('member.aboutus')"
            is-link
            to="/introduction"
          >
            <template #icon>
              <svg-icon icon-class="aboutus" class="member-icon" />
            </template>
          </van-cell>
        </van-cell-group>
        <div style="margin: 16px">
          <van-button class="web-btn" @click="LogOut">{{
            $t('member.log_out')
          }}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  TokenColorKey,
  setTokenbyName,
  getTokenbyName,
  removeToken
} from '@/utils/cookies'
export default {
  name: 'MemberInfo',
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  data () {
    return {
      checked: false,
      usr: { invit: null }
    }
  },
  mounted () {
    this.checked = getTokenbyName(TokenColorKey) == 'night'
    // this.getMemberInf()
  },
  methods: {
    changeTheme () {
      if (this.checked) {
        setTokenbyName(TokenColorKey, 'day')
        document.documentElement.style.setProperty('--background-color', '#fff')
        document.documentElement.style.setProperty(
          '--background-color1',
          '#e1e1ea'
        )
        document.documentElement.style.setProperty('--font-color', '#000')
      } else {
        setTokenbyName(TokenColorKey, 'night')
        document.documentElement.style.setProperty(
          '--background-color',
          '#102030'
        )
        document.documentElement.style.setProperty(
          '--background-color1',
          '#0b1622'
        )
        document.documentElement.style.setProperty('--font-color', '#fff')
      }
    },
    isIOS () {
      const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent)
      const isMac = navigator.platform.indexOf('Mac') > -1
      const isTouch = navigator.maxTouchPoints > 1
      return isAppleDevice || (isMac && isTouch)
    },
    Download () {
      window.location.href = this.isIOS()
        ? this.safeWapConfig.ios_url
        : this.safeWapConfig.android_url
    },
    getRzStatus (val) {
      let result = this.$t('member.awaiting_certification')
      switch (val) {
        case 1:
          result = this.$t('member.under_review')
          break
        case 2:
          result = this.$t('member.certified')
          break
      }
      return result
    },
    gethave_pay (val) {
      let result = this.$t('member.noset')
      if (val == 1) {
        result = this.$t('member.seted')
      }
      return result
    },
    tosharing () {
      this.$router.push(
        {
          name: 'invite',
          query: {
            code: this.usr.invit
          }
        },
        () => {}
      )
    },
    async getMemberInf () {
      await this.$http({
        method: 'post',
        url: 'getusr'
      }).then(res => {
        this.usr = res.data
      })
    },
    closeWin(){
      this.$emit('close-left')
    },
    async LogOut () {
      this.$emit('close-left')
      await this.$http({
        method: 'post',
        url: 'logout'
      }).then(() => {})
      removeToken()
      location.reload()
    }
  }
}
</script>

<style></style>
